module.exports = __webpack_public_path__ + "static/media/icon-moduleE9.76289879.png";